(function(){
  var pendingSave = null;
  var ODD={'0':1,'1':0,'2':5,'3':7,'4':9,'5':13,'6':15,'7':17,'8':19,'9':21,'A':1,'B':0,'C':5,'D':7,'E':9,'F':13,'G':15,'H':17,'I':19,'J':21,'K':2,'L':4,'M':18,'N':20,'O':11,'P':3,'Q':6,'R':8,'S':12,'T':14,'U':16,'V':10,'W':22,'X':25,'Y':24,'Z':23};
  function ev(c){return (c>='0'&&c<='9')?c.charCodeAt(0)-48:c.charCodeAt(0)-65;}
  function validCF(v){v=(v||'').trim().toUpperCase();if(!/^[A-Z0-9]{16}$/.test(v))return false;var s=0;for(var i=0;i<15;i++){s+=(i%2===0)?ODD[v[i]]:ev(v[i]);}return String.fromCharCode(65+(s%26))===v[15];}
  function validPIVA(v){v=(v||'').trim();if(!/^[0-9]{11}$/.test(v))return false;var s=0;for(var i=0;i<11;i++){var n=v.charCodeAt(i)-48;if(i%2){n*=2;if(n>9)n-=9;}s+=n;}return s%10===0;}
  function validDest(v){v=(v||'').trim();return /^[A-Za-z0-9]{7}$/.test(v)||/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);}
  function blockForForm(form){var bs=document.querySelectorAll('.cart-attribute-cf');for(var i=0;i<bs.length;i++){var r=bs[i].querySelector('input[name="attributes[Tipo cliente]"]');if(r&&r.form===form)return bs[i];}return null;}
  function isAz(b){var a=b.querySelector('.cf-type-toggle[value="Azienda"]');return !!(a&&a.checked);}
  function both(b){var t1=b.querySelector('.cf-optout-toggle'),t2=b.querySelector('.cf-optout-confirm-toggle');return !!(t1&&t1.checked&&t2&&t2.checked);}
  function sync(b){var o=both(b),h=b.querySelector('.cf-optout-value');if(h)h.value=o?'Sì':'';return o;}
  function clr(b){b.querySelectorAll('.cf-input').forEach(function(i){i.classList.remove('is-invalid');});b.querySelectorAll('.cf-error').forEach(function(e){e.classList.remove('is-visible');e.textContent='';});}
  function err(b,sel,ins,m){var e=b.querySelector(sel+' .cf-error');if(e){e.textContent=m;e.classList.add('is-visible');}(ins||[]).forEach(function(i){if(i)i.classList.add('is-invalid');});}

  // Apre il contenitore (modale bottom-sheet nel drawer, oppure <details> inline su /cart).
  function openCont(b){
    var m=b.querySelector('cart-addon-modal');
    if(m){try{if(typeof m.show==='function'){m.show();return;}}catch(e){}try{m.hidden=false;m.setAttribute('open','');}catch(e){}return;}
    var d=b.querySelector('details');
    if(d){try{d.open=true;}catch(e){}try{d.scrollIntoView({behavior:'smooth',block:'center'});}catch(e){}}
  }
  function closeCont(b){
    var m=b.querySelector('cart-addon-modal');
    if(m){try{if(typeof m.hide==='function'){m.hide();return;}}catch(e){}try{m.removeAttribute('open');}catch(e){}return;}
    var d=b.querySelector('details');
    if(d){try{d.open=false;}catch(e){}}
  }

  // Messaggi localizzati: li definisce cf-field.liquid in window.WS_CF_I18N (fallback italiano).
  function msg(k,fb){var d=window.WS_CF_I18N||{};return d[k]||fb;}

  // Normalizza + valida il blocco. Mostra gli errori; ritorna true se si puo' proseguire.
  function validate(b){
    var az=isAz(b), cf=b.querySelector('.cf-cf'), piva=b.querySelector('.cf-piva'), sdi=b.querySelector('.cf-sdi');
    if(cf)cf.value=cf.value.trim().toUpperCase(); if(piva)piva.value=piva.value.trim(); if(sdi)sdi.value=sdi.value.trim();
    if(az){if(cf)cf.value='';}else{if(piva)piva.value='';if(sdi)sdi.value='';}
    sync(b);
    if(both(b)){if(cf)cf.value='';if(piva)piva.value='';if(sdi)sdi.value='';clr(b);return true;}
    var t1=b.querySelector('.cf-optout-toggle');
    if(t1&&t1.checked){clr(b);err(b,(az?'.cf-block--azienda':'.cf-block--privato'),[],msg('err_optout','Per proseguire senza fattura conferma la rinuncia: spunta «Ho capito e rinuncio alla fattura».'));var c2=b.querySelector('.cf-optout-confirm-toggle');if(c2){try{c2.focus();}catch(x){}}return false;}
    clr(b);
    if(az){var okP=validPIVA(piva&&piva.value),okD=validDest(sdi&&sdi.value);if(okP&&okD)return true;if(!okP){err(b,'.cf-block--azienda',[piva],msg('err_vat','Partita IVA non valida (11 cifre).'));try{piva.focus();}catch(x){}}else{err(b,'.cf-block--azienda',[sdi],msg('err_sdi','Codice Destinatario non valido: 7 caratteri SDI oppure un indirizzo PEC.'));try{sdi.focus();}catch(x){}}return false;}
    if(validCF(cf&&cf.value))return true;
    err(b,'.cf-block--privato',[cf],(cf&&cf.value==='')?msg('err_tax_code_empty','Inserisci il Codice Fiscale (oppure spunta «Non voglio la fattura»).'):msg('err_tax_code','Codice Fiscale non valido.'));try{cf.focus();}catch(x){}return false;
  }

  function fiscalAttributes(b) {
    return {
      'Tipo cliente': isAz(b) ? 'Azienda' : 'Privato',
      'Codice Fiscale': b.querySelector('.cf-cf').value,
      'Partita IVA': b.querySelector('.cf-piva').value,
      'Codice Destinatario': b.querySelector('.cf-sdi').value,
      'Rinuncia fattura': sync(b) ? 'Sì' : ''
    };
  }

  function applyAttributes(attributes) {
    document.querySelectorAll('.cart-attribute-cf').forEach(function(b) {
      var company = attributes['Tipo cliente'] === 'Azienda';
      var optout = attributes['Rinuncia fattura'] === 'Sì';
      b.querySelectorAll('.cf-type-toggle').forEach(function(input) {
        input.checked = input.value === (company ? 'Azienda' : 'Privato');
      });
      b.querySelector('.cf-cf').value = attributes['Codice Fiscale'] || '';
      b.querySelector('.cf-piva').value = attributes['Partita IVA'] || '';
      b.querySelector('.cf-sdi').value = attributes['Codice Destinatario'] || '';
      b.querySelector('.cf-block--privato').hidden = company;
      b.querySelector('.cf-block--azienda').hidden = !company;
      b.querySelector('.cf-optout-toggle').checked = optout;
      b.querySelector('.cf-optout-confirm-toggle').checked = optout;
      b.querySelector('.cf-optout-confirm').hidden = !optout;
      b.classList.toggle('is-optout', optout);
      sync(b);
    });
  }

  function persist(b, button) {
    var attributes = fiscalAttributes(b);
    var label = button.querySelector('.btn__text');
    var originalLabel = label.textContent;
    var error = b.querySelector('.cf-save-error');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = msg('saving', 'Salvataggio…');
    error.textContent = '';
    error.classList.remove('is-visible');
    pendingSave = fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true
    }).then(function(response) {
      if (!response.ok) throw new Error('Fiscal attributes save failed: ' + response.status);
      return response.json();
    }).then(function(cart) {
      applyAttributes(cart.attributes);
      closeCont(b);
    }).catch(function() {
      error.textContent = msg('err_save', 'Non è stato possibile salvare i dati. Riprova prima di proseguire.');
      error.classList.add('is-visible');
      openCont(b);
    }).finally(function() {
      pendingSave = null;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = originalLabel;
    });
  }

  // Gate al checkout: se non valido, blocca e apre il contenitore con l'errore.
  document.addEventListener('submit',function(e){
    var form=e.target; if(!form||form.tagName!=='FORM')return;
    var sub=e.submitter; if(sub&&sub.name&&sub.name!=='checkout')return;
    var b=blockForForm(form); if(!b)return;
    if(pendingSave){e.preventDefault();e.stopPropagation();openCont(b);return;}
    if(validate(b))return;
    e.preventDefault(); e.stopPropagation();
    openCont(b);
  },true);

  // Conferma valida e salva sul carrello prima di chiudere il contenitore.
  document.addEventListener('click',function(e){
    var c=e.target.closest?e.target.closest('.cf-confirm'):null; if(!c)return;
    var b=c.closest('.cart-attribute-cf'); if(!b)return;
    e.preventDefault();
    if(pendingSave)return;
    if(validate(b)) persist(b,c);
  });

  document.addEventListener('change',function(e){
    var t=e.target; if(!t||!t.classList)return;
    if(t.classList.contains('cf-type-toggle')){var b=t.closest('.cart-attribute-cf');if(!b)return;var az=isAz(b);b.querySelector('.cf-block--privato').hidden=az;b.querySelector('.cf-block--azienda').hidden=!az;clr(b);}
    else if(t.classList.contains('cf-optout-toggle')){var b=t.closest('.cart-attribute-cf');if(!b)return;var conf=b.querySelector('.cf-optout-confirm'),c2=b.querySelector('.cf-optout-confirm-toggle');if(t.checked){if(conf)conf.hidden=false;}else{if(conf)conf.hidden=true;if(c2)c2.checked=false;}b.classList.toggle('is-optout',t.checked);clr(b);sync(b);}
    else if(t.classList.contains('cf-optout-confirm-toggle')){var b=t.closest('.cart-attribute-cf');if(!b)return;if(both(b))clr(b);sync(b);}
  });
})();
